var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconTag = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20837 7.62498C6.20837 8.0007 6.35763 8.36104 6.62331 8.62671C6.88898 8.89239 7.24932 9.04165 7.62504 9.04165C8.00076 9.04165 8.3611 8.89239 8.62678 8.62671C8.89245 8.36104 9.04171 8.0007 9.04171 7.62498C9.04171 7.24926 8.89245 6.88892 8.62678 6.62325C8.3611 6.35757 8.00076 6.20831 7.62504 6.20831C7.24932 6.20831 6.88898 6.35757 6.62331 6.62325C6.35763 6.88892 6.20837 7.24926 6.20837 7.62498Z",
    stroke: "#08121F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 5.5V12.827C1.25016 13.5784 1.54878 14.2989 2.08017 14.8302L13.0027 25.7527C13.6429 26.3928 14.5113 26.7525 15.4167 26.7525C16.3221 26.7525 17.1904 26.3928 17.8307 25.7527L25.7527 17.8307C26.3928 17.1904 26.7525 16.3221 26.7525 15.4167C26.7525 14.5113 26.3928 13.6429 25.7527 13.0027L14.8302 2.08017C14.2989 1.54878 13.5784 1.25016 12.827 1.25H5.5C4.37283 1.25 3.29183 1.69777 2.4948 2.4948C1.69777 3.29183 1.25 4.37283 1.25 5.5Z",
    stroke: "#08121F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_tag.14145f95.svg";
export { ForwardRef as ReactComponent };